export const FEES_CAPITALIZE_ALL_FEES = 'FEES_CAPITALIZE_ALL_FEES';
export const DUE_AT_SIGNING_SLIDE_OUT_TOGGLE = 'DUE_AT_SIGNING_SLIDE_OUT_TOGGLE';

export const APPLY_DUE_AT_SIGNING = 'APPLY_DUE_AT_SIGNING';
export const APPLY_DUE_AT_SIGNING_SUCCESS = 'APPLY_DUE_AT_SIGNING_SUCCESS';
export const APPLY_DUE_AT_SIGNING_FAILURE = 'APPLY_DUE_AT_SIGNING_FAILURE';

export const REQUEST_DUE_AT_SIGNING = 'REQUEST_DUE_AT_SIGNING';
export const REQUEST_ROLL_TO_PAYMENTS_SUCCESS_UPQ = 'REQUEST_ROLL_TO_PAYMENTS_SUCCESS_UPQ';
export const REQUEST_DUE_AT_SIGNING_FAILURE = 'REQUEST_DUE_AT_SIGNING_FAILURE';
export const REQUEST_DUE_AT_SIGNING_SUCCESS = 'REQUEST_DUE_AT_SIGNING_SUCCESS';

export const DAS_UPDATE_DOWNPAYMENT = 'DAS_UPDATE_DOWNPAYMENT';
export const DAS_UPDATE_FIRSTPAYMENT = 'DAS_UPDATE_FIRSTPAYMENT';
export const DAS_UPDATE_FEES_CAPITALIZED = 'DAS_UPDATE_FEES_CAPITALIZED';
export const DAS_UPDATE_TAXES_CAPITALIZED = 'DAS_UPDATE_TAXES_CAPITALIZED';
export const DAS_UPDATE_TARGET_CASH_AMOUNT_PAID = 'DAS_UPDATE_TARGET_CASH_AMOUNT_PAID';
export const DAS_UPDATE_EQUITY_ALLOCATION_METHOD = 'DAS_UPDATE_EQUITY_ALLOCATION_METHOD';

export const ADD_DUE_AT_SIGNING_INFO_MESSAGE = 'ADD_DUE_AT_SIGNING_INFO_MESSAGE';
export const REMOVE_DUE_AT_SIGNING_INFO_MESSAGE = 'REMOVE_DUE_AT_SIGNING_INFO_MESSAGE';
export const CLEAR_DUE_AT_SIGNING_INFO_MESSAGES = 'CLEAR_DUE_AT_SIGNING_INFO_MESSAGES';
export const CLEAR_DUE_AT_SIGNING_ERRORS = 'CLEAR_DUE_AT_SIGNING_ERRORS';
export const DAS_CLEAR_PAYMENT = 'DAS_CLEAR_PAYMENT';
